/* ============================================================
   ADEQO PANEEL-OPBOUW — 3D-stuk paneel dat zich in een lus in elkaar
   schuift: eerst het fineer om de MDF-kern, dan de lat op het vilt.
   Gedeeld door de houten-landing ([hw-opbouw], via collection-houten.js)
   en de productpagina (product-opbouw-adeqo, [data-paneel-opbouw]).

   Op de box:
     [data-tl-svg]            lege <svg> waarin getekend wordt
     [data-tl-layers]         JSON, van boven naar onder: [{color}, ...]
                              eerste = fineer, laatste = vilt
     data-lats="60,20,60,20"  optioneel: latbreedtes in mm (standaard 5 x 27)
     data-gap="13"            optioneel: tussenruimte in mm
     data-core="#1f1f1f"      optioneel: kleur van de MDF-kern (brandvertragend MDF is zwart)
     data-veneer-src="…"      optioneel: productfoto; de fineerkleur wordt
                              uit de middentonen gehaald (CDN stuurt CORS)
   Maten in mm zijn taalneutraal; alle tekst staat in de Liquid.
   ============================================================ */

(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';
  function hexToRgb(x) { x = (x || '').replace('#', ''); if (x.length === 3) x = x[0] + x[0] + x[1] + x[1] + x[2] + x[2]; return [parseInt(x.substr(0, 2), 16), parseInt(x.substr(2, 2), 16), parseInt(x.substr(4, 2), 16)]; }
  function shade(hex, f) { try { var c = hexToRgb(hex); return 'rgb(' + c.map(function (v) { return Math.max(0, Math.min(255, Math.round(v * f))); }).join(',') + ')'; } catch (e) { return hex; } }
  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var a in attrs) n.setAttribute(a, attrs[a]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function toHex(c) { return '#' + c.map(function (v) { return ('0' + Math.round(v).toString(16)).slice(-2); }).join(''); }

  /* Fineerkleur uit de productfoto (vrijstaand paneel op wit, de vaste
     opzet van de Akupanel-foto's). */
  function sampleVeneer(src, done) {
    var img = new Image(), finished = false;
    function finish(c) { if (!finished) { finished = true; done(c); } }
    setTimeout(function () { finish(null); }, 1500);
    img.crossOrigin = 'anonymous';
    img.onerror = function () { finish(null); };
    img.onload = function () {
      try {
        var cv = document.createElement('canvas'), S = 48;
        cv.width = S; cv.height = S;
        var cx = cv.getContext('2d');
        cx.drawImage(img, 0, 0, S, S);
        // Alleen de bovenste 70% (onderin staan witruimte en het
        // "3 zijdig"-plaatje), dan de pixels op helderheid gesorteerd: de
        // donkerste zijn de naden, de lichtste glans. De band daartussen
        // is het hout, ook bij zwart en wit eiken.
        var d = cx.getImageData(0, 0, S, Math.round(S * 0.7)).data, px = [];
        for (var i = 0; i < d.length; i += 4) px.push([d[i], d[i + 1], d[i + 2], d[i] + d[i + 1] + d[i + 2]]);
        px.sort(function (a, b) { return a[3] - b[3]; });
        var sel = px.slice(Math.floor(px.length * 0.42), Math.floor(px.length * 0.88)), r = 0, g = 0, b = 0;
        sel.forEach(function (p) { r += p[0]; g += p[1]; b += p[2]; });
        var n = sel.length;
        finish(n > 40 ? toHex([r / n, g / n, b / n]) : null);
      } catch (e) { finish(null); }
    };
    img.src = src;
  }

  function draw(box, svg, data, cVeneerIn) {
    // Kleuren van boven naar onder: fineer, MDF-kern, vilt. MDF is in het
    // echt lichtbeige; de legendakleur (grijs) leest daar niet als MDF, dus
    // alleen data-core overschrijft de kern (brandvertragend MDF is zwart).
    var cVeneer = cVeneerIn || (data[0] || {}).color || '#7a5c3e';
    var cCore = box.getAttribute('data-core') || '#cbbca2';
    var cFelt = (data[data.length - 1] || {}).color || '#2c2c2c';

    // Een stuk paneel in echte maten (mm). x = breedte, y = dikte (naar u
    // toe), z = lengte van de lat. Het fineer is flinterdun, dus op de kopse
    // kant ziet u vrijwel alleen MDF, net als bij het echte paneel.
    var lats = (box.getAttribute('data-lats') || '').split(',').map(parseFloat).filter(function (v) { return v > 0; });
    if (!lats.length) lats = [27, 27, 27, 27, 27];
    var GAP = parseFloat(box.getAttribute('data-gap')) || 13;
    var TL = 12, TF = 9, V = 0.6, N = lats.length, H = 104;
    var OFF_VENEER = 34, OFF_LAT = 30; // uit-elkaar-afstand in mm
    var xs = [], WT = GAP / 2;
    lats.forEach(function (w) { xs.push(WT); WT += w + GAP; });
    WT -= GAP / 2; // halve tussenruimte links en rechts
    // Breder stuk (bijv. wisselende lat) iets kleiner tekenen, zodat het
    // in hetzelfde kader past.
    var k = Math.min(1.75, 1.75 * 200 / WT), ox = 112, oy = 222 + (1.75 - k) * 40;
    var AX = 0.94, AY = 0.62; // schermrichting van x en y
    function P(x, y, z) { return [ox + (x * AX - y * AY) * k, oy + (x * 0.34 + y * 0.42 - z) * k]; }
    function pts(a) { return a.map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' '); }
    function quad(g, a, fill) { return el('polygon', { points: pts(a), fill: fill }, g); }
    // Verschuiving in mm langs y, omgerekend naar het scherm
    function dy(mm) { return [(-mm * AY * k).toFixed(1), (mm * 0.42 * k).toFixed(1)]; }

    svg.setAttribute('viewBox', '0 0 520 440');
    svg.innerHTML = '';

    // Licht kleurverloop over de voorkant van fineer en vilt
    var uid = 'pob' + Math.random().toString(36).slice(2, 7);
    var defs = el('defs', {}, svg);
    function grad(id, from, to) {
      var g = el('linearGradient', { id: uid + id, x1: 0, y1: 0, x2: 1, y2: 0.25 }, defs);
      el('stop', { offset: 0, 'stop-color': from }, g);
      el('stop', { offset: 1, 'stop-color': to }, g);
      return 'url(#' + uid + id + ')';
    }
    var fVeneer = grad('v', shade(cVeneer, 1.1), shade(cVeneer, 0.9));
    var fFelt = grad('f', shade(cFelt, 1.2), shade(cFelt, 0.85));

    // Vilt: voorkant, rechterzijkant, bovenkant
    var felt = el('g', { 'class': 'hw-build__felt' }, svg);
    quad(felt, [P(0, TF, 0), P(WT, TF, 0), P(WT, TF, H), P(0, TF, H)], fFelt);
    quad(felt, [P(WT, 0, 0), P(WT, TF, 0), P(WT, TF, H), P(WT, 0, H)], shade(cFelt, 0.8));
    quad(felt, [P(0, 0, H), P(WT, 0, H), P(WT, TF, H), P(0, TF, H)], shade(cFelt, 1.35));

    // Eerst alle kernen, dan al het fineer: zo klopt de overlap zowel
    // uit elkaar als in elkaar.
    var y0 = TF, y1 = TF + TL;
    var cores = [], shells = [];
    xs.forEach(function (x0, i) {
      var x1 = x0 + lats[i], ci = x0 + V, co = x1 - V, cf = y1 - V;
      var g = el('g', { 'class': 'hw-build__core' }, svg);
      quad(g, [P(ci, cf, 0), P(co, cf, 0), P(co, cf, H), P(ci, cf, H)], shade(cCore, 1.05));
      quad(g, [P(co, y0, 0), P(co, cf, 0), P(co, cf, H), P(co, y0, H)], shade(cCore, 0.82));
      quad(g, [P(ci, y0, H), P(co, y0, H), P(co, cf, H), P(ci, cf, H)], shade(cCore, 1.2));
      cores.push(g);
    });
    xs.forEach(function (x0, i) {
      var LAT = lats[i], x1 = x0 + LAT;
      var g = el('g', { 'class': 'hw-build__shell' }, svg);
      // Voorkant en rechterzijkant van het fineer
      quad(g, [P(x0, y1, 0), P(x1, y1, 0), P(x1, y1, H), P(x0, y1, H)], fVeneer);
      quad(g, [P(x1, y0, 0), P(x1, y1, 0), P(x1, y1, H), P(x1, y0, H)], shade(cVeneer, 0.72));
      // Bovenkant: het U-profiel van het fineer (voor, links, rechts)
      var top = shade(cVeneer, 1.25);
      quad(g, [P(x0, y1 - V, H), P(x1, y1 - V, H), P(x1, y1, H), P(x0, y1, H)], top);
      quad(g, [P(x0, y0, H), P(x0 + V, y0, H), P(x0 + V, y1, H), P(x0, y1, H)], top);
      quad(g, [P(x1 - V, y0, H), P(x1, y0, H), P(x1, y1, H), P(x1 - V, y1, H)], top);
      // Houtnerf: lange, licht slingerende lijnen in de lengte, op de
      // voorkant en (smaller) op de zijkant. Bredere lat, meer nerven.
      var seed = i * 13 + 7;
      function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
      var nerven = Math.max(4, Math.round(LAT / 3));
      for (var j = 0; j < nerven; j++) {
        var gx = x0 + 1.5 + rnd() * (LAT - 3), w = (rnd() - 0.5) * 1.6, pl = [];
        for (var q = 0; q <= 4; q++) pl.push(P(gx + Math.sin(q * 1.3 + j) * w, y1, 2 + (H - 4) * q / 4));
        el('polyline', { points: pts(pl), fill: 'none', stroke: shade(cVeneer, rnd() < 0.5 ? 0.82 : 1.14), 'stroke-width': (0.5 + rnd() * 0.7).toFixed(2), opacity: (0.45 + rnd() * 0.4).toFixed(2) }, g);
      }
      for (var j2 = 0; j2 < 3; j2++) {
        var gy = y0 + 2 + rnd() * (TL - 4), s0 = P(x1, gy, 3), s1 = P(x1, gy + (rnd() - 0.5), H - 3);
        el('line', { x1: s0[0].toFixed(1), y1: s0[1].toFixed(1), x2: s1[0].toFixed(1), y2: s1[1].toFixed(1), stroke: shade(cVeneer, 0.6), 'stroke-width': 0.5, opacity: 0.6 }, g);
      }
      shells.push(g);
    });

    // Nummers bewegen mee met hun onderdeel; maten verschijnen pas als
    // het paneel dicht is.
    function badge(parent, p, n, from) {
      if (from) el('line', { x1: from[0], y1: from[1], x2: p[0], y2: p[1], 'class': 'hw-build__lead' }, parent);
      el('circle', { cx: p[0], cy: p[1], r: 11, 'class': 'hw-build__badge' }, parent);
      var t = el('text', { x: p[0], y: p[1] + 4, 'class': 'hw-build__badge-n' }, parent); t.textContent = n;
    }
    // Nummer 2 op de laatste lat: boven de eerste latten staan de breedtematen
    var iFront = Math.min(2, N - 1), iCore = N - 1;
    var b1 = el('g', { 'class': 'hw-build__ann' }, svg);
    badge(b1, P(xs[iFront] + lats[iFront] / 2, y1, H * 0.42), '1');
    var b2 = el('g', { 'class': 'hw-build__ann' }, svg);
    var core = P(xs[iCore] + lats[iCore] / 2, (y0 + y1) / 2 - 1, H);
    badge(b2, [core[0] - 16, core[1] - 44], '2', core);
    var b3 = el('g', { 'class': 'hw-build__ann' }, svg);
    var fe = P(WT, TF / 2, H * 0.62);
    badge(b3, [fe[0] + 40, fe[1] + 4], '3', fe);

    var dims = el('g', { 'class': 'hw-build__ann hw-build__dims' }, svg);
    function line(a, b) { el('line', { x1: a[0], y1: a[1], x2: b[0], y2: b[1] }, dims); }
    function text(p, s, anchor) { var t = el('text', { x: p[0], y: p[1], 'text-anchor': anchor || 'middle' }, dims); t.textContent = s; }
    function mm(v) { return (Math.round(v * 10) / 10 + ' mm').replace('.', ','); }
    // Breedte boven elke latmaat die nog niet genoemd is (27, of 60 en 20)
    var up = 14, seen = {};
    xs.forEach(function (x0, i) {
      if (seen[lats[i]]) return;
      seen[lats[i]] = true;
      var a = P(x0, y0, H), b = P(x0 + lats[i], y0, H);
      line([a[0], a[1] - up], [b[0], b[1] - up]); line([a[0], a[1] - 3], [a[0], a[1] - up - 4]); line([b[0], b[1] - 3], [b[0], b[1] - up - 4]);
      text([(a[0] + b[0]) / 2 - 6, (a[1] + b[1]) / 2 - up - 12], mm(lats[i]));
    });
    if (N > 1) {
      var dn = 14, c = P(xs[0] + lats[0], y1, 0), d = P(xs[1], y1, 0);
      line([c[0], c[1] + dn], [d[0], d[1] + dn]); line([c[0], c[1] + 3], [c[0], c[1] + dn + 4]); line([d[0], d[1] + 3], [d[0], d[1] + dn + 4]);
      text([(c[0] + d[0]) / 2, (c[1] + d[1]) / 2 + dn + 18], mm(GAP));
    }
    var XN = xs[N - 1] + lats[N - 1];
    var off = 16, e0 = P(XN, 0, H), e1 = P(XN, y1, H);
    line([e0[0] + off, e0[1]], [e1[0] + off, e1[1]]);
    line([e0[0] + 3, e0[1]], [e0[0] + off + 4, e0[1]]); line([e1[0] + 3, e1[1]], [e1[0] + off + 4, e1[1]]);
    text([Math.max(e0[0], e1[0]) + off + 8, (e0[1] + e1[1]) / 2 + 4], mm(TF + TL), 'start');

    // p = 0 alles uit elkaar, p = 1 dicht. Eerst fineer op de kern
    // (0 tot 0,5), dan de lat op het vilt (0,45 tot 0,9), per lat iets
    // verspringend.
    function render(p) {
      for (var i = 0; i < N; i++) {
        var s = i * 0.035;
        var tv = ease(clamp((p - s) / 0.42));
        var tl = ease(clamp((p - 0.45 - s) / 0.4));
        var lat = OFF_LAT * (1 - tl), ven = lat + OFF_VENEER * (1 - tv);
        var dl = dy(lat), dv = dy(ven);
        cores[i].setAttribute('transform', 'translate(' + dl[0] + ' ' + dl[1] + ')');
        shells[i].setAttribute('transform', 'translate(' + dv[0] + ' ' + dv[1] + ')');
        if (i === iFront) b1.setAttribute('transform', 'translate(' + dv[0] + ' ' + dv[1] + ')');
        if (i === iCore) b2.setAttribute('transform', 'translate(' + dl[0] + ' ' + dl[1] + ')');
      }
      dims.style.opacity = clamp((p - 0.86) / 0.1);
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) { render(1); return; }

    // Doorlopende lus zolang de tekening in beeld is (ms): even los,
    // in elkaar schuiven, dicht met maten, weer uit elkaar.
    var HOLD_OPEN = 900, BUILD = 3000, HOLD_SHUT = 2600, OPEN = 1500;
    var LOOP = HOLD_OPEN + BUILD + HOLD_SHUT + OPEN;
    function at(t) {
      t = t % LOOP;
      if (t < HOLD_OPEN) return 0;
      t -= HOLD_OPEN; if (t < BUILD) return t / BUILD;
      t -= BUILD; if (t < HOLD_SHUT) return 1;
      t -= HOLD_SHUT; return 1 - t / OPEN;
    }
    var raf = 0, t0 = 0;
    function frame(now) {
      if (!t0) t0 = now;
      render(at(now - t0));
      raf = requestAnimationFrame(frame);
    }
    render(0);
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !raf) { t0 = 0; raf = requestAnimationFrame(frame); }
        else if (!e.isIntersecting && raf) { cancelAnimationFrame(raf); raf = 0; }
      });
    }, { threshold: 0.35 }).observe(svg);
  }

  function mount(box) {
    if (!box || box.__paneelOpbouw) return;
    box.__paneelOpbouw = true;
    var svg = box.querySelector('[data-tl-svg]');
    var data;
    try { data = JSON.parse(box.querySelector('[data-tl-layers]').textContent); } catch (e) { return; }
    if (!svg || !data.length) return;
    var src = box.getAttribute('data-veneer-src');
    if (!src) { draw(box, svg, data); return; }
    sampleVeneer(src, function (hex) {
      if (hex) box.style.setProperty('--veneer', hex);
      draw(box, svg, data, hex);
    });
  }

  window.AdeqoPaneelOpbouw = { mount: mount };

  function boot() { document.querySelectorAll('[data-paneel-opbouw]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
